
{
  "familyId": "SWW-LEEN-FRANS",
  "questions": [
    {
      "id": "SWW-LEEN-FRANS-001",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'parkeren' in: 'Hij ... de auto voor de deur.'?",
      "context": null,
      "options": ["parkeerde", "parkeertte", "parkeerte", "geparkeerd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Franse leenwoorden VT", "content": "Parkeren: stam = parkeer. Kofschip: r zit NIET in kofschip → +de. Verleden tijd: parkeer + de = parkeerde.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vt_parkeren",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel: Franse leenwoorden — drie regels combineren. Stap 1 (Franse spelling behouden): 'parkeren' komt van het Franse 'parquer'; de NL-spelling is 'parkeer'. Stap 2 (stam-regel): werkwoord − en = parkeer. Stap 3 (kofschip op klank): de laatste letter 'r' zit NIET in 't kofschip → -de. Stap 4: parkeer + de = parkeerde. Checkstrategie: doorloop expliciet stam-check → kofschip-check → uitgang-check, en vergelijk je vorm met de drie alternatieven. Sluit elk gemotiveerd uit: parkeertte (kofschip-fout), parkeerte (kofschip-fout), geparkeerd (VD i.p.v. VT).",
        "solutionSteps": ["Bepaal de stam: parkeren → parkeer", "Kofschip-check: r zit NIET in kofschip → -de", "parkeer + de = parkeerde", "Check: Franse -eren werkwoorden hebben stam op -eer → altijd -de in VT", "Sluit parkeertte, parkeerte, geparkeerd elk met een specifieke regel uit"],
        "distractorExplanations": {
          "0": "Correct! Drie regels samen: stam = parkeer (werkwoord − en), kofschip (r niet in kofschip) → -de, en juiste tijd (VT, geen VD). Resultaat: parkeerde.",
          "1": "Hier is -tte gebruikt in plaats van -de. De kofschip-regel faalt: 'r' zit NIET in 't kofschip → -de, niet -tte. Correct: parkeerde.",
          "2": "Hier is -te gebruikt. De kofschip-regel faalt: 'r' zit NIET in 't kofschip → -de. Correct: parkeerde.",
          "3": "Hier is het voltooid deelwoord gebruikt. De tijd-regel faalt: 'geparkeerd' hoort bij 'hebben geparkeerd'. Hier vraagt de zin om verleden tijd: parkeerde."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd toegepast (-tte i.p.v. -de)", "optionIndex": 1 },
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd toegepast (-te i.p.v. -de)", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord i.p.v. verleden tijd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-FRANS-002",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "verb_conjugation_flow",
      "question": "Vervoeg het Franse leenwerkwoord 'douchen' stap-voor-stap naar het voltooid deelwoord. Doorloop: stam-check → kofschip-check → ge- prefix.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "verb": "douchen",
        "targetForm": "voltooid deelwoord",
        "context": "Hij heeft ... na de wedstrijd.",
        "finalAnswer": "gedoucht",
        "steps": [
          {
            "id": "step1",
            "prompt": "Wat is de stam van 'douchen' (behoud de Franse spelling)?",
            "type": "choice",
            "options": [
              { "label": "douch", "value": "douch", "isCorrect": true },
              { "label": "douche", "value": "douche", "isCorrect": false, "feedback": "De Franse -e van 'douche' (zelfstandig naamwoord) blijft niet in de werkwoordstam. Werkwoord − en = douch." },
              { "label": "douc", "value": "douc", "isCorrect": false, "feedback": "De Franse 'ch' blijft behouden in de stam. Werkwoord − en = douch (met ch)." }
            ]
          },
          {
            "id": "step2",
            "prompt": "Kofschip-check: zit 'ch' in 't kofschip? Welke uitgang krijgt het VD?",
            "type": "choice",
            "options": [
              { "label": "+t (ch zit in kofSCHip)", "value": "+t", "isCorrect": true },
              { "label": "+d (ch zit niet in kofschip)", "value": "+d", "isCorrect": false, "feedback": "Kijk goed: het woord kofSCHip bevat letterlijk 'ch'. Dus 'ch' zit WEL in 't kofschip → +t." }
            ]
          },
          {
            "id": "step3",
            "prompt": "Vul het voltooid deelwoord in: ge + douch + t = ...",
            "type": "input",
            "acceptedAnswers": ["gedoucht"]
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van Franse leenwoorden", "content": "Douchen: stam = douch. De letters 'ch' staan letterlijk in het woord kofSCHip → +t. VD: ge + douch + t = gedoucht.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vd_douchen_flow",
      "variantIndex": 2,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Regel: voltooid deelwoord van Franse leenwoorden — drie regels via stap-voor-stap. Stap 1 (stam): douchen − en = douch (Franse 'ch' behouden, geen toegevoegde -e). Stap 2 (kofschip): kijk naar kofSCHip — de letters 'ch' staan er letterlijk in, dus 'ch' zit WEL in 't kofschip → +t. Stap 3 (ge-prefix): ge + douch + t = gedoucht. Checkstrategie: spel kofSCHip uit en kijk of de eindletters van je stam erin staan; combineer dan ge-prefix + stam + uitgang.",
        "solutionSteps": ["Stap 1: bepaal de stam — douchen − en = douch (Franse spelling)", "Stap 2: kofschip-check — 'ch' staat letterlijk in kof-SCH-ip → +t", "Stap 3: ge-prefix toevoegen — ge + douch + t = gedoucht", "Check: vergelijk met gedouchd (+d fout), gedouched (Engelse -ed), gedouchte (bijvoeglijke vorm)"]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd toegepast (+d i.p.v. +t)" },
          { "id": "sww.loanword-english-grammar", "label": "Engelse -ed gebruikt" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-FRANS-003",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd (meervoud) van 'masseren' in: 'Wij ... ons gisteren na de training.'?",
      "context": null,
      "options": ["masseerden", "masseertten", "maseerden", "gemasseerd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Franse leenwoorden VT meervoud", "content": "Masseren: stam = masseer. Kofschip: r zit NIET in kofschip → +de(n). Meervoud: masseer + den = masseerden.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vt_masseren",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Regel: drie afwegingen samen — Franse stam (dubbele s blijft), kofschip-regel, persoonsuitgang. Stap 1: 'masseren' komt van het Franse 'masser'; de stam is 'masseer' (dubbele s behouden!). Stap 2 (kofschip): r zit NIET in kofschip → -de(n). Stap 3 (persoon): 'Wij' is meervoud → -den. Stap 4: masseer + den = masseerden. Checkstrategie: doorloop expliciet Franse-spelling-check → kofschip-check → persoons-check, en sluit elk alternatief gemotiveerd uit.",
        "solutionSteps": ["Bepaal de stam: masseren → masseer (dubbele s behouden!)", "Kofschip-check: r zit NIET in kofschip → -de(n)", "'Wij' is meervoud → -den", "masseer + den = masseerden", "Sluit masseertten (kofschip-fout), maseerden (Franse ss verloren), gemasseerd (VD i.p.v. VT) uit"],
        "distractorExplanations": {
          "0": "Correct! Drie regels samen: stam masseer (dubbele s intact), kofschip (r niet in kofschip → -den), meervoud (Wij → -en). Resultaat: masseerden.",
          "1": "Hier is -tten gebruikt in plaats van -den. De kofschip-regel faalt: 'r' zit NIET in 't kofschip. Correct: masseerden.",
          "2": "Hier is een 's' weggelaten. De Franse-spelling-regel faalt: de stam is 'masseer' (met dubbele s, van het Franse 'masser'). Correct: masseerden.",
          "3": "Hier is het voltooid deelwoord gebruikt. De tijd-regel faalt: 'gemasseerd' hoort bij 'hebben'. Hier is verleden tijd meervoud nodig: masseerden."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd (-tten i.p.v. -den)", "optionIndex": 1 },
          { "id": "sww.loanword-double-consonant-lost", "label": "Franse dubbele s verloren", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord i.p.v. verleden tijd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-FRANS-004",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'controleren'?",
      "context": null,
      "options": ["gecontroleerd", "gecontrolert", "gecontroleet", "kontroleerd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van Franse leenwoorden", "content": "Controleren: stam = controleer. Kofschip: r zit NIET in kofschip → +d. VD: ge + controleer + d = gecontroleerd.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vd_controleren",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: VD van Franse leenwoorden — drie regels combineren. Stap 1 (Franse spelling): 'controleren' komt van het Franse 'contrôler'; de 'c' blijft 'c' (geen vernederlandsing naar 'k'). Stap 2 (stam): werkwoord − en = controleer (dubbele -ee behouden). Stap 3 (kofschip): r zit NIET in kofschip → +d. Stap 4: ge + controleer + d = gecontroleerd. Checkstrategie: vergelijk Franse herkomst → stam-vorming → kofschip-uitgang. Sluit elke distractor uit door te benoemen welke regel schendt.",
        "solutionSteps": ["Bepaal de stam: controleren → controleer (Franse 'c' blijft, dubbele -ee blijft)", "Kofschip-check: r zit NIET in kofschip → +d", "VD: ge + controleer + d = gecontroleerd", "Check: Franse -eren werkwoorden → stam op -eer → altijd +d", "Sluit gecontrolert (stam-fout), gecontroleet (kofschip-fout), kontroleerd (Frans c → NL k) uit"],
        "distractorExplanations": {
          "0": "Correct! Drie regels samen: Franse 'c' intact, stam = controleer (dubbele -ee), kofschip (r niet → +d). Resultaat: gecontroleerd.",
          "1": "Hier is de stam verkort. 'Gecontrolert' mist een -e van de stam 'controleer'. De stam-regel zegt: 'controleer' (niet 'controler'). Correct: gecontroleerd.",
          "2": "Hier is +t gebruikt in plaats van +d. De kofschip-regel faalt: 'r' zit NIET in 't kofschip → +d. Correct: gecontroleerd.",
          "3": "Hier is de spelling 'vernederlandst'. De Franse-spelling-regel faalt: 'c' blijft 'c' (niet 'k'). Correct: gecontroleerd."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.stem-extraction-error", "label": "Stam ingekort (dubbele e verloren)", "optionIndex": 1 },
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd (+t i.p.v. +d)", "optionIndex": 2 },
          { "id": "sww.loanword-spelling-dutchified", "label": "Franse c → NL k vernederlandst", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-FRANS-005",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "fill_in",
      "question": "Typ het voltooid deelwoord van 'reserveren'.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {"acceptedAnswers": ["gereserveerd"], "caseSensitive": false, "placeholder": "ge..."},
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van reserveren", "content": "Reserveren: stam = reserveer. Kofschip: r zit niet in kofschip → +d. VD: ge + reserveer + d = gereserveerd.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vd_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: VD Franse leenwoorden — drie regels via stap-voor-stap. Stap 1 (Franse spelling): 'reserveren' komt van 'réserver'; de stam wordt 'reserveer'. Stap 2 (kofschip): r zit NIET in kofschip → +d. Stap 3 (ge-prefix): ge + reserveer + d = gereserveerd. Checkstrategie: alle Franse -eren werkwoorden hebben stam op -eer en r zit niet in kofschip → altijd +d bij VD. Vergelijk met mogelijke fouten: 'gereserveert' (kofschip +t fout), 'gereservert' (stam ingekort).",
        "solutionSteps": ["Bepaal de stam: reserveren → reserveer", "Kofschip-check: r zit NIET in kofschip → +d", "VD: ge + reserveer + d = gereserveerd", "Check: vergelijk met 'gereserveert' (kofschip-fout) en 'gereservert' (stam-fout)"]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Mogelijke fout: 'gereserveert' (-t i.p.v. -d)" },
          { "id": "sww.stem-extraction-error", "label": "Mogelijke fout: 'gereservert' (stam ingekort)" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-FRANS-006",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst met Franse leenwoorden.",
      "context": null,
      "correctAnswer": 0,
      "data": {
        "text": "Hij heeft de kamer gereserveert na het overleg. Zij heeft alles gekontroleerd voordat ze vertrok.",
        "errors": [
          { "word": "gereserveert", "position": 4, "correction": "gereserveerd", "explanation": "Stam 'reserveer' eindigt op r, niet in kofschip, dus VD krijgt +d: gereserveerd." },
          { "word": "gekontroleerd", "position": 11, "correction": "gecontroleerd", "explanation": "Franse spelling 'c' blijft behouden in leenwoorden: gecontroleerd (niet gekontroleerd)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Franse leenwoorden", "content": "Stam = werkwoord min -en. Franse spelling (c, ch, dubbele s) blijft behouden. Kofschip-regel werkt zoals normaal: r niet in kofschip, dus -d in VD.", "icon": "lightbulb" } }
      ],
      "conceptId": "leen_frans_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee fouten in Franse leenwoorden, beide via dezelfde analyse: bepaal stam → kofschip-check → vergelijk met geschreven vorm én controleer Franse spelling. 'Gereserveert' moet 'gereserveerd' zijn (r-stam vraagt +d in VD). 'Gekontroleerd' moet 'gecontroleerd' zijn (Franse c blijft behouden, geen vernederlandsing). Checkstrategie: behoud altijd de Franse spelling, pas dan de kofschip-regel toe op de laatste stamletter.",
        "solutionSteps": [
          "Bepaal de stam, behoud Franse spelling",
          "Kofschip-check op laatste stamletter (r geeft -d)",
          "Vergelijk geschreven vorm met de regels",
          "Spot waar Franse spelling is vernederlandst (c → k)",
          "Spot waar kofschip-uitgang fout is (+t i.p.v. +d bij r-stam)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-dutchified", "label": "Franse c vervangen door NL k" },
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verkeerd bij r-stam (-t i.p.v. -d)" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-FRANS-007",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "matching",
      "question": "Koppel elk Frans leenwerkwoord aan het juiste voltooid deelwoord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "parkeren", "right": "geparkeerd" },
          { "left": "controleren", "right": "gecontroleerd" },
          { "left": "reserveren", "right": "gereserveerd" },
          { "left": "masseren", "right": "gemasseerd" },
          { "left": "douchen", "right": "gedoucht" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "VD-formule",
            "content": "ge + stam + t/d. R-stammen → +d. Ch-stammen → +t. Franse spelling (c, ch, ss) blijft altijd behouden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "leen_frans_vd_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Vijf koppelingen, vijf keer dezelfde analyse: Franse spelling behouden → stam = werkwoord − en → kofschip-check → ge + stam + t/d. parkeren → geparkeerd (r → +d); controleren → gecontroleerd (r → +d, c behouden); reserveren → gereserveerd (r → +d); masseren → gemasseerd (r → +d, ss behouden); douchen → gedoucht (ch → +t). Franse spelling overal intact. Checkstrategie: voor elk paar bepaal je eerst de eindletter van de stam, dan de kofschip-uitgang, en pas dan koppel je.",
        "solutionSteps": [
          "Werkwoord − en = stam (Franse spelling behouden)",
          "Kofschip-check: laatste stamletter in kofschip?",
          "ge + stam + t/d",
          "Check elke koppeling: klopt Franse spelling? klopt kofschip-uitgang?"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verkeerd gekozen" },
          { "id": "sww.loanword-spelling-dutchified", "label": "Franse spelling vernederlandst" }
        ]
      }
    }
  ]
}
